import type { RoomCredentials, TransportStatus, ViewRole } from "../types";

/** Shared links are invitations to a particular room, never permission to replace it. */
export function isExplicitRoomRoute(search: string, hash: string): boolean {
  return new URLSearchParams(search).has("view") ||
    new URLSearchParams(hash.replace(/^#/, "")).has("room");
}

/** Only the ordinary operator's own cached relay capability can be replaced once. */
export function shouldRecoverCachedRoom({
  role, explicitRoute, credentials, cached, status, attempted,
}: {
  role: ViewRole;
  explicitRoute: boolean;
  credentials: RoomCredentials | null;
  cached: RoomCredentials | null;
  status: TransportStatus;
  attempted: boolean;
}): boolean {
  return !attempted && !explicitRoute && role === "operator" &&
    status.kind === "relay" && !status.connected &&
    status.error === "Authentication failed" &&
    !!credentials?.relayUrl && !!credentials.controllerToken &&
    cached?.roomId === credentials.roomId &&
    cached.token === credentials.token &&
    cached.controllerToken === credentials.controllerToken &&
    cached.relayUrl === credentials.relayUrl;
}
